<ion-header *ngIf="onComeBack">
  <ion-toolbar>
    <ion-buttons>
      <ion-button fill="clear" (click)="onLoadMap()">
        Zurück zur Map
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="reloadTrigger">

  <!-- Default / Events App -->
  <ion-tabs  id="mainTabs" name="mainTabs" (ionTabsDidChange)="onTabChange($event)" [environmentInjector]="environmentInjector">
    <!-- ! appDetector.isEventsApp()  -->
    <ion-tab-bar slot="bottom" *ngIf="!appDetector.isEventsApp() && !appDetector.isForestApp() && !appDetector.isTournamentApp() && !appDetector.isLeaderBoardApp() && !appDetector.isGesunderApp()">
      <ion-tab-button tab="tab1" routerLink="/tabs/tab1">
        <ion-icon name="calendar"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_EVENTS' | translate }}</ion-label>
      </ion-tab-button>

      <ion-tab-button *ngIf="tabsNews" tab="tab7" routerLink="/tabs/tab7">
        <ion-icon name="paper"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_NEWS' | translate }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
    <!-- appDetector.isForestApp() -->
    <ion-tab-bar slot="bottom" *ngIf="appDetector.isForestApp()">
      <ion-tab-button tab="tab1"  (click)="setIconsDefault()" 
      [routerLinkActiveOptions]="{ exact: false }">
        <ion-icon name="calendar"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_EVENTS' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab3"  (click)="setIconsDefault()"
      [routerLinkActiveOptions]="{ exact: false }">
        <ion-icon name="trophy"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_RESULTS' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab4" (click)="fillRecIcon()">
        <ion-icon [name]="iconRecName" [class]="iconRecName"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_TRACK' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab5"  (click)="fillTrnIcon()">
        <ion-icon [name]="iconTrnName" [class]="iconTrnName"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_TRAINING' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab2" routerLink="/tabs/tab2" (click)="fillMeIcon()">
        <ion-icon [name]="iconMeName" [class]="iconMeName"></ion-icon>
        <ion-label>{{ 'IAM' | translate }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
      <!-- goforest end -->
      <!-- Tournament App -->
    <ion-tab-bar slot="bottom" *ngIf="appDetector.isTournamentApp()">
        <ion-tab-button tab="tab1" [routerLinkActiveOptions]="{ exact: false }" (click)="setIconsDefault()">
          <ion-icon name="calendar"></ion-icon>
          <ion-label>Turniere</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab13" [routerLinkActiveOptions]="{ exact: false }" (click)="touListTabPressed()">
          <ion-icon name="apps"></ion-icon>
          <ion-label>{{ 'GAMER_TAB' | translate }}</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab9" [routerLinkActiveOptions]="{ exact: false }" (click)="fillTshirtIcon()">
          <ion-icon [name]="iconTshirtNameBlue" [class]="iconTshirtNameBlue"></ion-icon>
          <ion-label>{{ 'NEARBY_COMPETITOR' | translate }}</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab10" [routerLinkActiveOptions]="{ exact: false }" (click)="fillFieldIcon()">
          <ion-icon [name]="iconFieldBlue" [class]="iconFieldBlue"></ion-icon>
          <ion-label>{{ 'LINEUP_TAB' | translate }}</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab12" routerLink="/tabs/tab12" [routerLinkActiveOptions]="{ exact: false }" (click)="fillRecIcon()">
          <ion-icon name="trophy"></ion-icon>
          <ion-label>{{ 'MAIN_TAB_RESULTS' | translate }}</ion-label>
        </ion-tab-button>
    </ion-tab-bar>
    <!-- Leaderboard App -->
    <ion-tab-bar slot="bottom" *ngIf="appDetector.isLeaderBoardApp()">
      <ion-tab-button tab="tab1" routerLink="/tabs/tab1" (click)="setIconsDefault()">
        <ion-icon name="calendar"></ion-icon>
        <ion-label>Events</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab3" routerLink="/tabs/tab3" (click)="setIconsDefault()">
        <ion-icon name="trophy"></ion-icon>
        <ion-label>Ergebnisse</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab8" routerLink="/tabs/tab8" (click)="fillRecIcon()">
        <ion-icon [name]="iconRecName"></ion-icon>
        <ion-label>Aufzeichnen</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab14" routerLink="/tabs/tab14" (click)="fillTrnIcon()">
        <ion-icon [name]="iconTrnName"></ion-icon>
        <ion-label>Anmeldungen</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab2" routerLink="/tabs/tab2" (click)="fillMeIcon()">
        <ion-icon [name]="iconMeName"></ion-icon>
        <ion-label>Wir</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
     <!-- Gesunder App -->
    <ion-tab-bar slot="bottom" *ngIf="appDetector.isGesunderApp()">
      <ion-tab-button tab="tab1" routerLink="/tabs/tab1" (click)="setIconsDefault()">
        <ion-icon name="calendar"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_EVENTS' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab6" routerLink="/tabs/tab6" (click)="setIconsDefault()">
        <ion-icon name="md-people"></ion-icon>
        <ion-label>{{ 'TEAM_RESULTS' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab7" routerLink="/tabs/tab7">
        <ion-icon name="paper"></ion-icon>
        <ion-label>{{ 'MAIN_TAB_NEWS' | translate }}</ion-label>
      </ion-tab-button>
      <ion-tab-button tab="tab2" routerLink="/tabs/tab2" (click)="fillMeIcon()">
        <ion-icon [name]="iconMeName"></ion-icon>
        <ion-label>{{ 'IAM' | translate }}</ion-label>
      </ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
</ion-content>
